import { createGlobalStyle } from 'styled-components';

import reset from './reset';
import scrollApp from './scrollApp';
import utility from './utility';

const GlobalStyle = createGlobalStyle`
    ${reset}
    ${scrollApp}
    ${utility}
`;

export default GlobalStyle;
